import { INode } from 'shared/types/tree'
import { nodeListNeedsTypeUpdate } from '../utility/utility'
import { nodesOfTypeWithContentV2 } from '../../utility/TreeHelpers'
import { NodeType } from 'shared/types/ingestion'

export function nodeListsWithTypeIssue(tree: INode) {
  const extraCheck = (n: INode) =>
    nodeListNeedsTypeUpdate(n) && !!n.nodes.length
  return nodesOfTypeWithContentV2({
    tree,
    types: [NodeType.NodeList],
    extraCheck,
  })
}
